import priceCardSkeletonDesktop from './skeletons/price-card-desktop.svg';
import priceCardSkeletonMobile from './skeletons/price-card-mobile.svg';
import userMenuSkeletonDesktop from './skeletons/user-menu-desktop.svg';
import userMenuSkeletonMobile from './skeletons/user-menu-mobile.svg';

export { priceCardSkeletonDesktop, priceCardSkeletonMobile, userMenuSkeletonDesktop, userMenuSkeletonMobile };
